import { useParams } from 'react-router-dom';
import useIsJiraIntegrationActive from '../../../../pages/NRSettings/NRIntegrations/NRJiraIntegration/useIsJiraIntegrationActive';
import NRActiveVulnerabilityJiraTickets from './NRActiveVulnerabilityJiraTickets';

function NRVulnerabilityJiraTickets({ advisoryId, vulnerabilityData, cveDetails, sx, expandJiraTickets = false }) {
  const { componentId: assetId } = useParams();
  const { isJiraIntegrationActive, isJiraDisconnected, isJiraIntegrationLoading, canDirectReconnect } = useIsJiraIntegrationActive();
  const hasExistingTickets = Boolean(vulnerabilityData?.jiraTicketCount);
  const showDisconnectedTickets = isJiraDisconnected && hasExistingTickets;

  if (isJiraIntegrationLoading || !assetId || !advisoryId || !vulnerabilityData?.componentId) {
    return null;
  }

  if (!isJiraIntegrationActive && !showDisconnectedTickets) {
    return null;
  }

  return (
    <NRActiveVulnerabilityJiraTickets
      advisoryId={advisoryId}
      assetId={assetId}
      vulnerabilityData={vulnerabilityData}
      cveDetails={cveDetails}
      sx={sx}
      expandJiraTickets={expandJiraTickets}
      isDisconnected={showDisconnectedTickets}
      canDirectReconnect={canDirectReconnect}
    />
  );
}

export default NRVulnerabilityJiraTickets;
